import {call} from "redux-saga/effects";
import * as HttpService from 'services/HttpService';
import {takeLatest, put} from 'redux-saga/effects';
import {
    getClaimsList,
    claimsSuccess,
    claimsFailed,
    getClaim,
    claimSuccess,
    claimFailed,
    updateClaimStatus,
    claimStatusUpdateSuccess,
    claimStatusUpdateFailed,
    createNewClaim,
    claimCreated,
    claimCreationFailed,
    deleteClaim,
    claimDeletedSuccessfully,
    claimDeletionFailed,
} from "../slices/claimsSlice";
import { notification } from 'antd';

const endpoint = '/admin/claims';

function* fetchClaims(action) {
    try {
        const response = yield call(HttpService.get, endpoint, action.payload);
        const {claims} = response.data;
        if (claims) {
            yield put(claimsSuccess(claims));
        }
    } catch (error) {
        yield put(claimsFailed());
    }
}

function* fetchClaim(action) {
    const {id} = action.payload;
    try {
        const response = yield call(HttpService.get, `${endpoint}/${id}`);
        const {claim} = response.data;
        if (claim) {
            yield put(claimSuccess(claim));
        }
    } catch (error) {
        yield put(claimFailed());
    }
}

function* createClaim(action) {
    try {
        const response = yield call(HttpService.post, `${endpoint}`, action.payload);
        if (response) {
            notification.success({message: 'Claim created', description: 'New Claim created successfully'});
            yield put(claimCreated());
        }
    } catch (error) {
        yield put(claimCreationFailed());
    }
}

function* patchClaimStatus(action) {
    const {id, status, payment_status} = action.payload;
    try {
        const response = yield call(HttpService.patch, `${endpoint}/${id}`, {status, payment_status});
        if (response) {
            notification.success({message: 'Claim updated', description: 'Claim status updated successfully'});
            yield put(claimStatusUpdateSuccess());
        }
    } catch (error) {
        yield put(claimStatusUpdateFailed());
    }
}

function* deleteClaimRequest(action) {
    const {id} = action.payload;
    try {
        const response = yield call(HttpService.del, `${endpoint}/${id}`);
        if (response) {
            notification.success({message: 'Claim deleted', description: 'Claim deleted successfully'});
            yield put(claimDeletedSuccessfully({id}));
        }
    } catch (error) {
        yield put(claimDeletionFailed());
    }
}

export default function* resourcesSaga() {
    yield takeLatest(getClaimsList.type, fetchClaims);
    yield takeLatest(getClaim.type, fetchClaim);
    yield takeLatest(createNewClaim.type, createClaim);
    yield takeLatest(deleteClaim.type, deleteClaimRequest);
    yield takeLatest(updateClaimStatus.type, patchClaimStatus);
}
